import { ActionTree } from 'vuex';
import { IModalState } from './modal-types.store';

export const actions: ActionTree<IModalState, any> = {
    
}